// 所有表格行相同的配置
const columnPublicConfig = {
    align: 'center'
}

// 筛选器配置
const filterItemsConfig = {
    scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon'
    }
}

// 表格配置
/**
 * title: 表格标题
 * dataIndex: 后端返回的这个标题的名字
 * filterIndex: 筛选器字段，一般和dataIndex一样，如果是选择型的筛选器，这里填写id字段
 * key: 随便选择dataIndex或filterIndex中的一个
 * type: 筛选器类型，input = 输入框，select = 选择框
 * multi: 如果选择型筛选器需要多选，就写上值为true
 * items: 选择型筛选器必须带上这个，默认为空数组
 */
// 订单信息
export const columns = [{
    title: '订单编号',
    dataIndex: 'number',
    key: 'number',
    width: 240,
    ...columnPublicConfig,
},
{
    title: '客户名称',
    dataIndex: 'name',
    filterIndex: 'cli_id',
    key: 'name',
    type: 'auto-input',
    items: [],
    width: 160,
    ...columnPublicConfig,
    ...filterItemsConfig
},
{
    title: '客户类型',
    dataIndex: 'ctyname',
    filterIndex: 'ctyid',
    key: 'ctyname',
    type: 'select',
    items: [],
    ...columnPublicConfig,
    ...filterItemsConfig
},
{
    title: '商品类型',
    dataIndex: 'goodsname',
    filterIndex: 'goodsname',
    key: 'goodsname',
    type: 'select',
    multi: true,
    items: [],
    ...columnPublicConfig,
    ...filterItemsConfig
},
{
    title: '商品规格',
    dataIndex: 'specification',
    filterIndex: 'specification',
    key: 'specification',
    type: 'select',
    multi: true,
    items: [],
    ...columnPublicConfig,
    ...filterItemsConfig
},
{
    title: '总瓶数',
    dataIndex: 'amount',
    key: 'amount',
    ...columnPublicConfig
},
{
    title: '总重量',
    dataIndex: 'weight',
    key: 'weight',
    ...columnPublicConfig
},
{
    title: '总价',
    dataIndex: 'money',
    key: 'money',
    ...columnPublicConfig
},
{
    title: '支付方式',
    dataIndex: 'payname',
    filterIndex: 'pay',
    key: 'payname',
    type: 'select',
    items: [],
    ...columnPublicConfig,
    ...filterItemsConfig
},
{
    title: '气站名称',
    dataIndex: 'statusname',
    filterIndex: 'status',
    key: 'statusname',
    type: 'select',
    items: [
        {
            id: '1',
            name: '城乡'
        },
        {
            id: '2',
            name: '永液'
        },
        {
            id: '3',
            name: '中燃'
        },
        {
            id: '4',
            name: '楠溪'
        },
        {
            id: '5',
            name: '全部'
        },
    ],
    ...columnPublicConfig,
    ...filterItemsConfig
},
{
    title: '创建时间',
    dataIndex: 'created_at',
    key: 'created_at',
    ...columnPublicConfig
}]

// 液化气销售情况
export const columnsA = [
    {
        title: '液化气规格',
        dataIndex: 'specification',
        key: 'specification',
        ...columnPublicConfig
    },
    {
        title: '数量',
        dataIndex: 'amount',
        key: 'amount',
        ...columnPublicConfig
    },
    {
        title: '重量',
        dataIndex: 'weight',
        key: 'weight',
        ...columnPublicConfig
    },
    {
        title: '金额',
        dataIndex: 'money',
        key: 'money',
        ...columnPublicConfig
    }
]

// // 钢瓶进出库情况
// export const columnsB = [
//     {
//         title: '液化气规格',
//         dataIndex: 'money',
//         key: 'money',
//         ...columnPublicConfig
//     },
// ]

// 欠款还款情况
export const columnsC = [
    {
        title: '客户名称',
        dataIndex: 'name',
        key: 'name',
        ...columnPublicConfig
    },
    {
        title: '金额',
        dataIndex: 'paymoney',
        key: 'paymoney',
        ...columnPublicConfig
    },
]

// 汇总数据
export const columnsD = [
    {
        title: '名称',
        dataIndex: 'name',
        key: 'name',
        ...columnPublicConfig
    },
    {
        title: '金额',
        dataIndex: 'money',
        key: 'money',
        ...columnPublicConfig
    },
]